"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.form.knowledge.label': '知识条目',
    'profession.form.title.edit': '编辑职业',
    'profession.form.title.add': '添加职业',
    'profession.form.back': '返回',
    'profession.form.name.label': '名称',
    'profession.form.name.placeholder': '职业名称',
    'profession.form.branch.label': '行业',
    'profession.form.branch.placeholder': '选择行业',
    'profession.form.description.label': '描述',
    'profession.form.description.placeholder': '输入职业描述',
    'profession.form.image.label': '图片',
    'profession.form.image.placeholder': '上传职业图片',
    'profession.form.knowledge.placeholder': '搜索知识条目...',
    'profession.form.common.label': '通用职业',
    'profession.form.active.label': '活跃',
    'profession.form.steps.label': '选择步骤',
    'profession.form.submit.update': '更新职业',
    'profession.form.submit.create': '创建职业',
    'profession.form.branches.load.error': '加载行业失败',
    'profession.form.steps.load.error': '加载步骤失败',
    'profession.form.load.error': '加载职业失败',
    'profession.form.update.success': '职业更新成功',
    'profession.form.action.success': '职业',
    'profession.form.action.error': '职业操作失败',
    'profession.form.action.failed': '失败',
    'profession.form.update': '更新',
    'profession.form.create': '创建',
};
